import { render, staticRenderFns } from "./EditBulkSubmission.vue?vue&type=template&id=9202da7a&scoped=true"
import script from "./EditBulkSubmission.vue?vue&type=script&lang=js"
export * from "./EditBulkSubmission.vue?vue&type=script&lang=js"
import style0 from "./EditBulkSubmission.vue?vue&type=style&index=0&id=9202da7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9202da7a",
  null
  
)

export default component.exports